import { useState } from 'react'

export function useTrackHover() {
  const [isHover, setIsHover] = useState(false)
  return {
    isHover,
    onMouseEnter: () => setIsHover(true),
    onMouseLeave: () => setIsHover(false),
  }
}
